import { useTranslation } from "react-i18next"
import { useEffect, useState } from "react"

import Form from "./Form"
import { AdminFormDialog } from "components/partials"
import {
    toRow,
    toTableData,
    getFormTitle
} from "common/helpers/admin-page-func.helper"
import { useAdminState, useAdminDispatch, ActionCreators } from "../Context"
import { UsersApi } from "../api"
import { CompaniesApi } from "common/api"
import { useAppSelector, useLocalStorage } from "common/hooks"
import { LocalStorageKey } from "common/helpers"
import { AuthActions } from "store/actions"

import Button from "@material-ui/core/Button"
import CoreDialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"

import { DialogTitle } from "components/partials"
import { Alert } from "components/widgets"



const Dialog = () => {
    const { t } = useTranslation()
    const dispatch = useAdminDispatch()
    const { rowToEdit, params } = useAdminState()
    const { filter, pagination } = params

    const authActions = AuthActions.useActions()
    const [, setUserInLocalStorage] = useLocalStorage(LocalStorageKey.User)

    const { user: currentUser } = useAppSelector(state => state.auth)
    const formData = rowToEdit ? rowToEdit : {}
    const isEditMode = Boolean(formData.id)
    const areActionsDisabled =
        currentUser?.role !== "Superadmin" && !Boolean(formData.enabled)

    const [isDialogOpen, setIsDialogOpen] = useState(false);

    const [addUserDisabled, setAddUserDisabled] = useState(false);

    useEffect(() => {
        const debug = false;

        CompaniesApi.get().then(response => {

            setAddUserDisabled(false);

            if (currentUser?.role !== "Superadmin" && response?.data?.length > 0) {
                const currCompany = response.data[0];
                debug && console.log('unlimitedUserLicenses:', currCompany.unlimitedUserLicenses)
                debug && console.log('userLicenses:', currCompany.userLicenses)
                debug && console.log('users.length:', currCompany.users.length)

                if (!currCompany.unlimitedUserLicenses) {
                    if (currCompany.users.length >= currCompany.userLicenses) {
                        debug && console.log('Es können keine weiteren Benutzer angelegt werden!');
                        setAddUserDisabled(true);
                    }
                }
            }
        })
    }, [rowToEdit])

    useEffect(() => {
        const hasFormData = Boolean(rowToEdit && Object.entries(rowToEdit).length)
        setIsDialogOpen(hasFormData)
    }, [rowToEdit])

    function onExited() {
        dispatch(ActionCreators.setToEdit(null))
    }

    function onClose() {
        setIsDialogOpen(false)
    }

    async function submitCallback(formData) {
        const requestFunc = isEditMode ? UsersApi.update : UsersApi.create

        let payload = formData
        if (
            !payload.password?.trim().length ||
            (!isEditMode && !payload.verified)
        ) {
            const { password, ...rest } = payload
            payload = rest
        }

        const response = await requestFunc(payload)

        if (currentUser && currentUser.id === payload.id) {
            setUserInLocalStorage(response.data)
            authActions.login(response.data)
        }

        if (filter && pagination) {
            onClose()
            UsersApi.get({ filter, pagination, refetch: true }).then(response => {
                dispatch(ActionCreators.loaded(toTableData(response)))
            })
            return
        }

        if (isEditMode) {
            dispatch(ActionCreators.updateRow(toRow(response.data)))
        } else {
            dispatch(ActionCreators.addRow(toRow(response.data)))
        }
    }

    function onClickDelete() {
        dispatch(ActionCreators.setToDelete([rowToEdit]))
    }

    if (addUserDisabled && !isEditMode) {
        return (
            <CoreDialog open={isDialogOpen} onClose={onClose}>
                <DialogTitle onClose={onClose}>{"Nutzer anlegen"}</DialogTitle>

                <DialogContent>
                    <Alert severity="error" marginBottom={2}>
                        {"Es können keine weiteren Nutzer angelegt werden!"}
                    </Alert>
                </DialogContent>

                <DialogActions>
                    <Button onClick={onClose}>{'OK'}</Button>
                </DialogActions>
            </CoreDialog>
        )
    } else {
        return (
            <AdminFormDialog
                formData={formData}
                submitCallback={submitCallback}
                FormComponent={Form}
                DialogProps={{
                    open: isDialogOpen,
                    onClose,
                    TransitionProps: {
                        onExited
                    }
                }}
                DialogTitleProps={{
                    children: getFormTitle(
                        t("view.admin.user"),
                        isEditMode ? "edit" : "create"
                    )
                }}
                {...(isEditMode && { onClickDelete })}
                DeleteButtonProps={{ disabled: areActionsDisabled }}
                SubmitButtonProps={{ disabled: areActionsDisabled }}
            />
        )
    }
}

export default Dialog
